import * as common from './modules/common'
import * as insights from './modules/insights'
import * as pbc from './modules/pbc-management'
import * as system from './modules/system'
import * as clientUser from './modules/clientUser'
import * as kpTMember from './modules/kpTMember'
import * as status from './modules/accountStatus'
import * as general from './modules/general'
import * as clientRoles from './modules/clientRoles'
import * as kpUserRole from './modules/kpUserRole'
import * as matterLogs from './modules/matterLogs'
import * as businessHome from './modules/businessHome'
import * as exchange from './modules/exchange'
import * as confirmation from './modules/confirmation'
import * as componentUserRoles from './modules/componentUserRoles'
import * as clientAdmin from './modules/client-admin'

export default {
    common,
    insights,
    pbc,
    system,
    clientUser,
    kpTMember,
    status,
    general,
    clientRoles,
    matterLogs,
    kpUserRole,
    businessHome,
    exchange,
    confirmation,
    componentUserRoles,
    clientAdmin
}
